<template>
  <div class="w-100">
    <div class="d-flex flex-row flex-wrap">
        <v-flex xs3 class="px-0 pl-3 maximum-step-content" style="overflow-y:auto">
            <h3 class="subheading pt-2 mb-2 pl-1"> DESIGN THE CHAT FLOW </h3>
            <!-- <div style="border:1px solid lightgrey;overflow-y:auto;height:90%"> -->
            <div style="border:1px solid lightgrey;">
            <div class="flex-row d-flex flex-wrap mt-0">
                <div class="flex px-1 py-2 sm12 mt-2 b-bottom
                  d-inline-flex cursor-pointer question-type pl-4"
                  @click="updateQuestionSource('campaign')"
                >
                <v-icon color="primary" small class="mt-0 mr-3"
                  style="max-width:40px"
                >fa fa-copy</v-icon>
                  <span class="darken-1" style="font-size:16px">
                    Copy from existing touchpoint
                  </span>
                </div>
                <div class="flex b-bottom px-1 py-2 mt-2 b-bottom sm12
                  d-inline-flex cursor-pointer question-type pl-4"
                  @click="updateQuestionSource('question_bank')">
                  <v-icon color="primary" small class="mt-0 mr-3"
                  style="max-width:40px;">fa fa-clipboard-list</v-icon>
                  <span class="darken-1" style="font-size:16px">
                      Create using existing template
                  </span>
                </div>
            </div>

            <h3 class="subheading mt-3 pt-3 pl-1"> <strong> Draft a new question </strong></h3>
            <h2 class="grey--text subheading-text subheading b-bottom pl-1">
              Choose a question type to add new question
            </h2>
            <!--<h3 class="subheading pt-2 mb-2 pl-1">Bot Responses/Questions</h3>-->
            <div class=" flex-row flex-wrap d-flex mt-0">
              <div class="flex px-1 py-2 sm12 mt-2 b-bottom cursor-pointer question-type"
                v-for="(b, bi) in questionTypes" :key="bi" @click="updateQuestion(b)"
              >
                <div class="d-flex">
                  <v-icon color="primary" small class="mt-0 mr-3 ml-3" style="max-width:40px;">
                    {{b.img}}
                  </v-icon>
                  <span class="darken-1" style="font-size:16px">
                  {{b.title}}
                  </span>
                </div>
                <div class="d-flex">
                  <span style="max-width:40px;">
                    <v-icon small class="mt-0 mr-3"></v-icon>
                  </span>
                  <span class="grey--text" style="font-size:10px;margin-left:35px">
                  {{b.description}}
                  </span>
                </div>
              </div>
            </div>

            <!--<h3 class="subheading pt-2 mb-2 pl-1">Emoji Scale</h3>-->
            <div class="mt-0">
                <div class="flex px-1 py-2 sm12 mt-2 b-bottom cursor-pointer question-type"
                @click="updateQuestion(config.emojiScale)">
                <div class="d-flex">
                    <v-icon color="primary" small class="mt-0 mr-3 ml-3" style="max-width:40px;">
                      {{config.emojiScale.img}}
                    </v-icon>
                    <span class="darken-1" style="font-size:16px">
                    {{config.emojiScale.title}}
                    </span>
                </div>
                <div class="d-flex">
                    <span style="max-width:40px;">
                      <v-icon small class="mt-0 mr-3"></v-icon>
                    </span>
                    <span class="grey--text" style="font-size:10px;margin-left:35px">
                    {{config.emojiScale.description}}
                    </span>
                </div>
                </div>
            </div>

            <!--<h3 class="subheading pt-2 mb-2 pl-1">Responses/Questions with Driver</h3>-->
            <div class="mt-0">
                <div class="flex px-1 py-2 sm12 mt-2 b-bottom cursor-pointer question-type"
                v-for="(b, bi) in questionTypesD" :key="bi" @click="updateQuestion(b)">
                <div class="d-flex">
                    <v-icon color="primary" small class="mt-0 mr-3 ml-3" style="max-width:40px;">
                      {{b.img}}
                    </v-icon>
                    <span class="darken-1" style="font-size:16px">
                    {{b.title}}
                    </span>
                </div>
                <div class="d-flex">
                  <span style="max-width:40px;">
                    <v-icon small class="mt-0 mr-3"></v-icon>
                  </span>
                  <span class="grey--text" style="font-size:10px;margin-left:35px">
                    {{b.description}}
                  </span>
                </div>
                </div>
            </div>

            <div class="mt-0">
            <!-- <div class="mt-0 d-flex flex-row"> -->
                <div class="flex px-1 py-2 sm12 mt-2 b-bottom cursor-pointer question-type"
                v-for="(b, bi) in statements" :key="bi" @click="updateQuestion(b)">
                <div class="d-flex">
                    <v-icon color="primary" small class="mt-0 mr-3 ml-3" style="max-width:40px;">
                      {{b.img}}
                    </v-icon>
                    <span class="darken-1" style="font-size:16px">
                    {{b.title}}
                    </span>
                </div>
                <div class="d-flex">
                    <span style="max-width:40px;">
                      <v-icon small class="mt-0 mr-3"></v-icon>
                    </span>
                    <span class="grey--text" style="font-size:10px;margin-left:35px">
                    {{b.description}}
                    </span>
                </div>
                </div>
            </div>

            <!--<h3 class="subheading mt-3 pt-3 pl-1"> <strong>
              Draft Amara's statement
            </strong></h3>-->
            <!--<h2 class="grey--text subheading b-bottom pl-1">
              Choose a question type to add new question
            </h2>-->
            </div>
        </v-flex>

        <v-flex xs9 class="maximum-step-content interactions" style="overflow-y:auto">
          <v-card class=" box-container interaction-card">
            <div class="drag-container flex-row d-flex grey lighten-5">
              <v-flex>
                <v-card height="220" class="text-center pt-5 ma-5 box-container"
                  v-show="newSurvey.interactions.length === 0 && !drag.startDragging">
                <v-icon large color="#0d2c8d">las la-hand-paper</v-icon>
                <p class="headline font-weight-bold mt-4">No questions added</p>
                <span>Select question type or question to create survey.</span>
                </v-card>

                <!-- <Container group-name="1"
                class="pt-4"
                @drop="onDrop($event)"
                :drag-end="onDragEnd"
                :get-child-payload="getIPayload"
                drag-handle-selector=".handle"
                >
                <Draggable v-for="(q, qi) in newSurvey.interactions" :key="qi"> -->
                <draggable
                  :list="newSurvey.interactions"
                  class="list-group"
                  ghost-class="ghost"
                  :move="checkMove"
                  @start="dragging = true"
                  @end="dragging = false"
                >
                  <!-- <v-card height="220" class="draggable-item text-center pt-5 ma-5 box-container"
                    v-show="drag && newSurvey.interactions.length === 0"
                    key="blank-response"
                  >
                    <v-icon large color="success">las la-thumbs-up</v-icon>
                    <p class="headline font-weight-bold mt-4">You are doing great!</p>
                    <span>Now drop the action here.</span>
                  </v-card> -->

                  <div class="draggable-item d-flex"
                    v-for="(q, qi) in newSurvey.interactions"
                    :key="qi"
                  >
                    <v-flex class="pa-3 my-4 action-card text-center" sm12>
                        <!-- <div class="actions d-flex flex-column"
                          v-if="qi !== 0"
                          :style="getDragPosition(q.type)"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon color="grey" class="mb-3 handle" v-bind="attrs" v-on="on">
                              las la-arrows-alt
                              </v-icon>
                            </template>
                              Move
                          </v-tooltip>
                        </div> -->

                        <div class="mb-1 box-container">
                        <p v-if="(q.msg_tl && q.msg_tl.length > 0) || (q.msg_ms && q.msg_ms.length > 0)" style="margin-bottom:0px; text-align:right;padding-right: 10px;padding-top: 5px;">
                          <span v-if="(q.msg_tl && q.msg_tl.length > 0) && (q.msg_ms && q.msg_ms.length > 0)">2 Translations are available : </span> <span v-else>1 Translation is available : </span>
                          <a @click="editLanguageBasisQue(q, 'ms', 'Malay')"
                          v-if="q.msg_ms && q.msg_ms.length > 0">
                          <v-chip
                            class="ma-2"
                            color="primary"
                            style="cursor: pointer;"
                          >
                            Malay
                          </v-chip></a><a  @click="editLanguageBasisQue(q, 'tl', 'Filipino')"  v-if="q.msg_tl && q.msg_tl.length > 0">
                          <v-chip
                            class="ma-2"
                            color="primary"
                            style="cursor: pointer;"
                          >
                            Filipino
                          </v-chip></a></p>
                        <div style="min-height:48px" class="d-flex flex-wrap flex-row">
                            <v-flex class="text-left">
                              <!-- <div class="d-flex" v-if="qi !== 0"> -->
                              <div v-if="qi !== 0">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="grey" class="handle pt-3 pl-3" v-bind="attrs" v-on="on">
                                    las la-arrows-alt
                                    </v-icon>
                                  </template>
                                    Move
                                </v-tooltip>
                              </div>
                            </v-flex>
                            <v-flex xs1 v-if="q.type !== 'text' && qi !== 0"
                              class="font-weight-bold pl-2 pt-2 mt-1"
                            >
                              Driver
                            </v-flex>
                            <v-flex v-if="q.type !== 'text' && qi !== 0" lay class="text-left driver-name" xs3>
                              <v-select
                                class="remove-msg"
                                :items="drivers"
                                item-text="name"
                                item-value="value"
                                chips
                                small-chips
                                :id="`role_${qi}`"
                                :name="`role_${qi}`"
                                solo flat
                                disabled
                                :error-messages="errors.collect(`role_${qi}`)"
                                v-validate="'required'"
                                v-model="q.driver"
                                label="Select from the list"
                              ></v-select>
                            </v-flex>

                            <v-flex xs2 v-if="q.type !== 'text' && qi !== 0" class="font-weight-bold pl-2 pt-2 mt-1 text-left">
                              Sub Driver
                            </v-flex>
                            <v-flex v-if="q.type !== 'text' && qi !== 0" lay class="text-left sub-driver-name" xs3>
                              <v-select
                                class="remove-msg"
                                :items="subDrivers"
                                item-text="name"
                                item-value="value"
                                chips
                                small-chips
                                :id="`subrole_${qi}`"
                                :name="`subrole_${qi}`"
                                data-vv-as="subdriver"
                                solo flat
                                disabled
                                :error-messages="errors.collect(`subrole_${qi}`)"
                                v-model="q.sub_driver"
                                v-validate="'required'"
                                label="Select from the list"
                              ></v-select>
                            </v-flex>

                            <v-spacer> </v-spacer>

                            <v-flex xs2 class="text-center">
                              <div class="d-flex flex-row">
                                <v-flex xs4>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="grey" class="mt-3" @click="editAction(q, qi, true)"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                    las la-edit
                                    </v-icon>
                                  </template>
                                    Edit
                                </v-tooltip>
                                </v-flex>
                                <v-flex xs4 v-if="qi !== 0">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon color="grey" class="mt-3" @click="deleteAction(qi)"
                                        v-bind="attrs"
                                        v-on="on"
                                      >las la-trash
                                      </v-icon>
                                    </template>
                                      Delete
                                  </v-tooltip>
                                </v-flex>
                                <v-flex xs4>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon color="grey" class="mt-3" @click="duplicateAction(q)"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                      las la-copy
                                      </v-icon>
                                    </template>
                                      Copy
                                  </v-tooltip>
                                </v-flex>
                                <v-flex xs4>
                                  <v-menu
                                    bottom
                                    :close-on-click="closeOnClick"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon color="grey" class="mt-3"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                      las la-language
                                      </v-icon>
                                    </template>
                                    <!-- eslint-disabled -->
                                    <v-list>
                                      <v-list-item
                                        v-for="(item, index) in user.language_mappings"
                                        :key="index"
                                        @click="editAction(q, qi, true, item)"
                                        v-if="item.language_code !== 'en'"
                                        :disabled="(item.language_code === 'tl' && q.msg_tl && q.msg_tl.length > 0) || (item.language_code === 'ms' && q.msg_ms && q.msg_ms.length > 0)"
                                      >
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </v-flex>
                              </div>
                            </v-flex>
                            <v-flex xs12>
                            <v-divider></v-divider>
                            </v-flex>
                        </div>

                        <div class="pt-4 pa-3 d-flex flex-row flex-wrap align-center">
                            <!-- Scale -->
                            <v-flex class="offset-1" xs10 v-if="q.type === 'scale'">
                            <v-text-field
                                v-if="q.msg"
                                maxlength="300"
                                v-model="q.msg[0].text"
                                class="elevation-0 grey--text text--lighten-2"
                                name="interactionText"
                                :error-messages="errors.collect('interactionText')"
                                label="Question"
                                autofocus
                                data-vv-as="interaction text"
                                v-validate="'required'"
                                single-line
                                disabled
                                outlined
                            >
                            </v-text-field>

                            <div class="d-flex flex-row flex-wrap justify-center"
                              v-if="q.msg && q.msg[0].scaleType === 'emoji'"
                            >
                                <v-flex xs2 class="text-center"
                                v-for="(r, ri) in q.msg[0].scale" :key="ri">
                                <v-menu
                                    absolute
                                    disabled
                                    offset-y
                                    style="max-width: 600px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="emoji-btn"
                                    slot="activator"
                                    fab text rounded disabled
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                    <img v-if="r.img" :src="getImgUrl(r.img)"
                                    class="emoji-container" />
                                    </v-btn>
                                  </template>
                                    <v-list class="pa-3">
                                    <v-text-field
                                        class="grey--text text--lighten-2"
                                        maxlength="50"
                                        outlined
                                        v-model="r.title"
                                        flat
                                        @click.stop
                                        name="quickReply"
                                        :label="`Rating ${ri+1}`"
                                        disabled
                                    ></v-text-field>

                                    <v-text-field
                                        class="grey--text text--lighten-2"
                                        maxlength="300"
                                        outlined
                                        v-model="r.postback"
                                        flat
                                        @click.stop
                                        name="postback"
                                        label="Amara's response"
                                        disabled
                                    ></v-text-field>

                                    <v-flex xs12 class="text-right">
                                        <v-btn color="#0d2c8d" class="white--text" small disabled>
                                          Done
                                        </v-btn>
                                    </v-flex>
                                    </v-list>
                                </v-menu>
                                <p class="text-center">
                                    {{r.title}}
                                </p>
                                </v-flex>
                            </div>

                            <div class="d-flex flex-row flex-wrap justify-center"
                              v-if="q.msg && q.msg[0].scaleType === 'number'">
                                <v-flex xs2 class="text-center"
                                  v-for="(r, ri) in q.msg[0].scale" :key="ri"
                                >
                                <v-menu
                                    absolute
                                    offset-y
                                    disabled
                                    style="max-width: 600px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="emoji-btn"
                                      :color="r.color"
                                      outlined
                                      text
                                      fab
                                      large
                                      v-bind="attrs"
                                      v-on="on"
                                      depressed
                                    >
                                      <strong class="headline">
                                        {{r.value}}
                                      </strong>
                                    </v-btn>
                                  </template>
                                    <v-list class="pa-3">
                                    <v-text-field
                                        class="grey--text text--lighten-2"
                                        maxlength="50"
                                        outlined
                                        v-model="r.title"
                                        flat
                                        disabled
                                        @click.stop
                                        name="quickReply"
                                        :label="`Rating ${ri+1}`"
                                    ></v-text-field>

                                    <v-text-field
                                        class="grey--text text--lighten-2"
                                        maxlength="300"
                                        outlined
                                        v-model="r.postback"
                                        flat
                                        disabled
                                        @click.stop
                                        name="postback"
                                        label="Amara's response"
                                    ></v-text-field>

                                    <v-flex xs12 class="text-right">
                                        <v-btn color="#0d2c8d"  class="white--text" small disabled>
                                          Done
                                        </v-btn>
                                    </v-flex>
                                    </v-list>
                                </v-menu>
                                <p class="text-center">
                                    {{r.title}}
                                </p>
                                </v-flex>
                            </div>
                            </v-flex>

                            <!-- Input from user -->
                            <v-flex class="offset-1" xs10 v-if="q.type === 'textInput'">
                            <v-text-field
                                maxlength="300"
                                v-model="q.msg['0'].text"
                                class="elevation-0 grey--text text--lighten-2"
                                :name="`interactionText_${qi}`"
                                :error-messages="errors.collect(`interactionText_${qi}`)"
                                label="Question"
                                autofocus
                                disabled
                                data-vv-as="interaction text"
                                v-validate="'required'"
                                single-line
                                outlined
                            >
                                <v-fade-transition slot="prepend">
                                <img width="30" height="30"
                                :src="getImgUrl('amara-60')">
                                </v-fade-transition>
                            </v-text-field>
                            </v-flex>

                            <!-- Text -->
                            <v-flex class="offset-1" xs10 v-if="q.type === 'text'">
                            <v-text-field
                                maxlength="300"
                                v-model="q.msg['0'].text"
                                class="elevation-0 grey--text text--lighten-2"
                                :name="`interactionText_${qi}`"
                                :error-messages="errors.collect(`interactionText_${qi}`)"
                                label="What should Amara say?"
                                autofocus
                                disabled
                                data-vv-as="interaction text"
                                v-validate="'required'"
                                single-line
                                outlined
                            >
                                <v-fade-transition slot="prepend">
                                <img width="30" height="30"
                                :src="getImgUrl('amara-60')">
                                </v-fade-transition>
                            </v-text-field>
                            </v-flex>

                            <!-- Image -->
                            <v-flex class="" v-if="q.type === 'image'">
                            <v-menu
                                absolute
                                v-if="q.msg"
                                offset-y
                                style="max-width: 600px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-img
                                height="200"
                                width="300"
                                slot="activator"
                                v-bind="attrs"
                                v-on="on"
                                max-height="200"
                                max-width="300"
                                v-if="q.msg"
                                :src="q.msg[0].imgUrl"
                                :lazy-src="q.msg[0].imgUrl"
                                aspect-ratio="1"
                                class="grey lighten-2 mx-auto"
                                >
                                <div
                                  class="d-flex flex-row fill-height align-center justify-center ma-0"
                                  slot="placeholder"
                                >
                                  <div class="">
                                    <v-icon class="mr-2">las la-plus-square</v-icon>
                                    <strong class="mb-2">
                                      Add Image
                                    </strong>
                                    </div>
                                    <v-progress-circular v-show="q.msg && q.msg[0].imgUrl"
                                    indeterminate color="grey lighten-5">
                                    </v-progress-circular>
                                  </div>
                                </v-img>
                                </template>
                                <v-list class="pa-3">
                                <v-text-field
                                    maxlength="1000"
                                    outlined
                                    v-if="q.msg"
                                    v-model="q.msg[0].imgUrl"
                                    flat
                                    disabled
                                    @click.stop
                                    name="url"
                                    label="Your image URL"
                                ></v-text-field>
                                <v-flex xs12 class="text-right">
                                    <v-btn color="#0d2c8d"  class="white--text" small disabled>
                                      Done
                                    </v-btn>
                                </v-flex>
                                </v-list>
                            </v-menu>
                            </v-flex>

                            <!-- Card -->
                            <v-flex class="" v-if="q.type === 'card'">
                            <v-card class="mx-auto" width="300"
                                v-for="(c, ci) in q.msg" :key="ci"
                            >
                                <v-menu
                                absolute
                                offset-y
                                style="max-width: 600px"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                <v-img
                                  height="200"
                                  width="300"
                                  slot="activator"
                                  max-height="200"
                                  max-width="300"
                                  :src="c.imgUrl"
                                  v-bind="attrs"
                                  v-on="on"
                                  :lazy-src="c.imgUrl"
                                  aspect-ratio="1"
                                  class="grey lighten-2 mx-auto"
                                >
                                    <div
                                      class="d-flex flex-row fill-height align-center justify-center ma-0"
                                      slot="placeholder"
                                    >
                                    <div class="">
                                        <v-icon class="mr-2">las la-plus-square</v-icon>
                                        <strong class="mb-2">
                                        Add Image
                                        </strong>
                                    </div>
                                    <v-progress-circular v-show="c.imgUrl"
                                    indeterminate color="grey lighten-5">
                                    </v-progress-circular>
                                    </div>
                                </v-img>
                                </template>
                                <v-list class="pa-3">
                                    <v-text-field
                                    maxlength="1000"
                                    outlined
                                    v-model="c.imgUrl"
                                    flat
                                    disabled
                                    @click.stop
                                    name="url"
                                    label="Your image URL"
                                    ></v-text-field>
                                    <v-flex xs12 class="text-right">
                                    <v-btn color="#0d2c8d"  class="white--text" small disabled>
                                      Done
                                    </v-btn>
                                    </v-flex>
                                </v-list>
                                </v-menu>
                                <h3 class="headline mb-0 font-weight-bold w-100">
                                <v-text-field
                                    maxlength="300"
                                    solo
                                    v-model="c.text"
                                    flat
                                    disabled
                                    @click.stop
                                    name="cardTitle"
                                    label="Enter your message here"
                                ></v-text-field>
                                </h3>
                                <div>
                                <v-textarea
                                    maxlength="500"
                                    flat
                                    rows="2"
                                    solo
                                    disabled
                                    v-model="c.description"
                                    name="cardDescription"
                                    label="Enter card description here"
                                ></v-textarea>
                                </div>

                                <v-card-actions>
                                <div class="text-left">
                                    <v-menu v-for="(r, ri) in c.quickReplies" :key="ri"
                                    absolute
                                    offset-y
                                    disabled
                                    class="mb-1"
                                    style="width: 20em;"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="#0d2c8d" block outlinedd slot="activator" v-bind="attrs" v-on="on">
                                    {{r.title}}</v-btn>
                                    </template>
                                    <v-list class="pa-3">
                                        <v-text-field
                                        class="grey--text text--lighten-2"
                                        maxlength="50"
                                        outlined
                                        v-model="r.title"
                                        flat
                                        disabled
                                        @click.stop
                                        name="quickReply"
                                        :label="`Rating ${ri+1}`"
                                        ></v-text-field>

                                        <v-text-field
                                        class="grey--text text--lighten-2"
                                        maxlength="300"
                                        outlined
                                        v-model="r.postback"
                                        flat
                                        disabled
                                        @click.stop
                                        name="postback"
                                        label="Amara's response"
                                        ></v-text-field>

                                        <v-flex xs12 class="text-right">
                                        <v-btn color="error" small text disabled
                                        @click="deleteReply(qi, ci, ri)">Delete</v-btn>
                                        <v-btn color="#0d2c8d"  class="white--text" small disabled>
                                          Done
                                        </v-btn>
                                        </v-flex>
                                    </v-list>
                                    </v-menu>

                                    <!-- Add new quick reply -->
                                    <p class="cursor-pointer mb-0 text-sm-center"
                                    v-if="c.quickReplies.length < 5"
                                    style="width: 20em;" @click="addReplies(qi, ci, 'Button')">
                                    <v-btn color="accent" class="mr-2" small outlined icon disabled>
                                        <v-icon small>las la-plus</v-icon>
                                    </v-btn>Add reply
                                    </p>
                                </div>
                                </v-card-actions>
                            </v-card>
                            </v-flex>

                            <!-- Carousel -->
                            <v-flex class="" v-if="q.type === 'carousel'">
                            <div class="flex-row flex-wrap d-flex">
                                <v-card class="mr-3" width="300"
                                  v-for="(c, ci) in q.msg" :key="ci"
                                >
                                <v-menu
                                    absolute
                                    disabled
                                    offset-y
                                    style="max-width: 600px"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-img
                                    height="200"
                                    width="300"
                                    v-bind="attrs"
                                    v-on="on"
                                    slot="activator"
                                    max-height="200"
                                    max-width="300"
                                    :src="c.imgUrl"
                                    :lazy-src="c.imgUrl"
                                    aspect-ratio="1"
                                    class="grey lighten-2 mx-auto"
                                    >
                                    <div
                                      class="d-flex flex-wrap flex-row fill-height align-center justify-center ma-0"
                                      slot="placeholder"
                                    >
                                        <div class="">
                                        <v-icon class="mr-2">las la-plus-square</v-icon>
                                        <strong class="mb-2">
                                            Add Image
                                        </strong>
                                        </div>
                                        <v-progress-circular v-show="c.imgUrl"
                                        indeterminate color="grey lighten-5">
                                        </v-progress-circular>
                                    </div>
                                    </v-img>
                                </template>
                                    <v-list class="pa-3">
                                    <v-text-field
                                        maxlength="1000"
                                        outlined
                                        v-model="c.imgUrl"
                                        flat
                                        disabled
                                        @click.stop
                                        name="url"
                                        label="Your image URL"
                                    ></v-text-field>
                                    <v-flex xs12 class="text-right">
                                        <v-btn color="#0d2c8d"  class="white--text" small disabled>
                                          Done
                                        </v-btn>
                                    </v-flex>
                                    </v-list>
                                </v-menu>
                                <h3 class="headline mb-0 font-weight-bold w-100">
                                    <v-text-field
                                    maxlength="300"
                                    solo
                                    v-model="c.text"
                                    flat
                                    disabled
                                    @click.stop
                                    name="cardTitle"
                                    label="Enter your message here"
                                    ></v-text-field>
                                </h3>
                                <div>
                                    <v-textarea
                                    maxlength="500"
                                    flat
                                    disabled
                                    rows="2"
                                    solo
                                    v-model="c.description"
                                    name="cardDescription"
                                    label="Enter card description here"
                                    ></v-textarea>
                                </div>

                                <v-card-actions>
                                    <div class="text-left">
                                    <v-menu v-for="(r, ri) in c.quickReplies" :key="ri"
                                        absolute
                                        offset-y
                                        class="mb-1"
                                        style="width: 20em;"
                                    >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn color="#0d2c8d" block outlinedd slot="activator" v-bind="attrs" v-on="on">
                                        {{r.title}}</v-btn>
                                    </template>
                                        <v-list class="pa-3">
                                        <v-text-field
                                            class="grey--text text--lighten-2"
                                            maxlength="50"
                                            outlined
                                            v-model="r.title"
                                            flat
                                            disabled
                                            @click.stop
                                            name="quickReply"
                                            :label="`Rating ${ri+1}`"
                                        ></v-text-field>

                                        <v-text-field
                                            class="grey--text text--lighten-2"
                                            maxlength="300"
                                            outlined
                                            v-model="r.postback"
                                            flat
                                            disabled
                                            @click.stop
                                            name="postback"
                                            label="Amara's response"
                                        ></v-text-field>

                                        <v-flex xs12 class="text-right">
                                            <v-btn color="error" small text
                                            @click="deleteReply(qi, ci, ri)" disabled>Delete</v-btn>
                                            <v-btn color="#0d2c8d"  class="white--text" small disabled>
                                              Done
                                            </v-btn>
                                        </v-flex>
                                        </v-list>
                                    </v-menu>

                                    <!-- Add new quick reply -->
                                    <p class="cursor-pointer mb-0 text-sm-center"
                                    v-if="c.quickReplies.length < 5"
                                    style="width: 20em;" @click="addReplies(qi, ci, 'Button')">
                                        <v-btn color="accent" class="mr-2" small disabled outlinedd icon>
                                        <v-icon small>las la-plus</v-icon>
                                        </v-btn>Add reply
                                    </p>
                                    </div>
                                </v-card-actions>
                                </v-card>
                                <!-- Add new quick reply -->
                                <v-card>
                                <p class="cursor-pointer mb-0 text-sm-center"
                                v-if="q.msg.length < 5"
                                style="width: 20em;" @click="addCard(qi)">
                                    <v-btn color="accent" class="mr-2" small disabled outlinedd icon>
                                    <v-icon small>las la-plus</v-icon>
                                    </v-btn>Add card
                                </p>
                                </v-card>
                            </div>
                            </v-flex>

                            <!-- Quick replies -->
                            <v-flex class="offset-1" xs10
                            v-if="q.type === 'quickReplies' || q.type === 'closeEnded'">
                            <v-text-field
                                v-if="q.msg"
                                maxlength="300"
                                class="elevation-0 grey--text text--lighten-2"
                                v-model="q.msg[0].text"
                                :name="`interactionText`"
                                :error-messages="errors.collect('interactionText')"
                                label="Question"
                                autofocus
                                disabled
                                data-vv-as="interaction text"
                                v-validate="'required'"
                                single-line
                                outlined
                            >
                                <v-fade-transition slot="prepend">
                                <img width="30" height="30"
                                :src="getImgUrl('amara-60')">
                                </v-fade-transition>
                            </v-text-field>

                            <div class="text-left" v-if="q.msg">
                                <v-menu v-for="(c, ci) in q.msg[0].quickReplies" :key="ci"
                                absolute
                                disabled
                                offset-y
                                style="max-width: 600px"
                                >
                                <template v-slot:activator="{ on, attrs }">
                                <v-btn color="#0d2c8d" outlinedd slot="activator" disabled v-bind="attrs" v-on="on">
                                  {{c.title}}
                                </v-btn>
                                </template>
                                <v-list class="pa-3">
                                    <v-text-field
                                    class="grey--text text--lighten-2"
                                    maxlength="50"
                                    outlined
                                    v-model="c.title"
                                    flat
                                    disabled
                                    @click.stop
                                    name="quickReply"
                                    :label="`Rating ${ci+1}`"
                                    ></v-text-field>

                                    <v-text-field
                                    class="grey--text text--lighten-2"
                                    maxlength="300"
                                    outlined
                                    v-model="c.postback"
                                    flat
                                    disabled
                                    @click.stop
                                    name="postback"
                                    label="Amara's response"
                                    ></v-text-field>

                                    <v-flex xs12 class="text-right">
                                    <v-btn color="error" small text
                                    v-if="q.type === 'quickReplies'"
                                    @click="deleteReply(qi, 0, ci)" disabled>Delete</v-btn>
                                    <v-btn color="#0d2c8d"  class="white--text" small disabled>
                                      Done
                                    </v-btn>
                                    </v-flex>
                                </v-list>
                                </v-menu>

                                <!-- Add new quick reply -->
                                <span class="cursor-pointer" @click="addReplies(qi, 0, 'Answer')"
                                v-if="q.msg && q.msg[0].quickReplies.length < 5
                                && q.type === 'quickReplies'">
                                <v-btn color="accent" small disabled outlinedd icon>
                                    <v-icon small>las la-plus</v-icon>
                                </v-btn>Add reply
                                </span>
                            </div>
                            </v-flex>

                        </div>
                        </div>
                    </v-flex>
                  </div>
                </draggable>
                <!-- </Container> -->
              </v-flex>
            </div>
          </v-card>
        </v-flex>
    </div>

  <newQuestion ref="newQuestion" v-show="questionSource === 'new'"></newQuestion>
  <questionBank ref="question_bank" v-show="questionSource === 'question_bank'"></questionBank>
  <campaigns ref="campaign" v-show="questionSource === 'campaign'"></campaigns>

  </div>
</template>

<script>
/* eslint-disable max-len */
/* eslint-disable quotes */
import { mapState, mapActions } from 'vuex';
import draggable from 'vuedraggable';
// import { Container, Draggable } from 'vue-smooth-dnd';

// import { ContentLoader } from 'vue-content-loader';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import axios from 'axios';
import newQuestion from './stageNewQuestion';
import questionBank from './stageQuestionBank';
import campaigns from './stageTemplates';
// import {
//   VCheckbox,
//   VAlert,
//   VAvatar,
//   VAutocomplete,
//   VTooltip
// } from 'vuetify';
dayjs.extend(relativeTime);

export default {
  name: 'uploadEmployees',
  components: {
    draggable,
    // ContentLoader,
    // Container,
    // Draggable,
    // VCheckbox,
    // VAlert,
    // VAvatar,
    // VAutocomplete,
    // VTooltip,
    newQuestion,
    questionBank,
    campaigns
  },
  data () {
    return {
      unlockStepper: false,
      audienceSource: null,
      selectedQuesType: null,
      newQuestion: {
        title: '',
        description: '',
        questions: [],
        type: ''
      },
      validate: {
        step1: true,
        step2: true,
        step3: true,
        step4: true,
        step5: true
      },
      newStage: {
        time: '',
        status: 'live',
        type: 'lifecycle',
        title: '',
        notifications: [],
        audience: {},
        survey: {
          id: null,
          title: 'No question set'
        },
        triggerTimeDuration: 3,
        triggerTimeUnit: 'weeks',
        triggerTimeReference: 'joining_date',
        triggerTimeIn: '+',
        triggerDate: new Date().toISOString().substr(0, 10),
        triggerTime: new Date().toISOString().substr(11, 5)
      },
      drag: {
        startDragging: false,
        droppingNow: false
      },
      newSurvey: {
        title: '',
        description: '',
        interactions: [],
        interactions_ms: [],
        interactions_tl: [],
        type: 'lifecycle'
      },
      questionSource: null,
      questionTypesD: [{
        delay: 2000,
        title: 'Rating scale',
        description: 'The respondent selects the number that most accurately represents their response',
        type: 'scale',
        role: '',
        img: 'las la-arrows-alt-h',
        msg: [{
          text: '',
          scaleType: 'number',
          scale: [
            {
              title: 'Awful',
              color: 'red',
              value: 1,
              postback: 'I am really sorry to hear that'
            }, {
              title: 'Not very good',
              color: 'deep-orange',
              value: 2,
              postback: 'That\'s not good'
            }, {
              title: 'Good',
              color: 'orange',
              value: 3,
              postback: 'I think we can improve'
            }, {
              title: 'Really good',
              color: 'light-green',
              value: 4,
              postback: 'That\'s good to know'
            }, {
              title: 'Brilliant',
              color: 'green',
              value: 5,
              postback: 'I am happy to know'
            }
          ]
        }],
        responseRequired: true,
        response: []
      }, {
        delay: 2000,
        title: 'Yes/No',
        description: 'Used where ambiguity is the enemy',
        type: 'closeEnded',
        msg: [{
          text: '',
          quickReplies: [
            {
              title: 'Yes',
              value: 5,
              postback: 'Good to know!'
            }, {
              title: 'No',
              value: 1,
              postback: 'That\'s sad'
            }
          ]
        }],
        img: 'las la-reply-all',
        responseRequired: true,
        response: []
      }],
      statements: [{
        delay: 2000,
        title: `Filler statement by Amara`,
        type: 'text',
        img: 'las la-align-left',
        msg: [{
          text: ''
        }],
        responseRequired: false,
        response: []
      }],
      questionTypes: [{
        delay: 2000,
        title: 'Open ended question',
        description: 'This require respondents to type their answer into a comment box',
        type: 'textInput',
        img: 'las la-keyboard',
        msg: [{
          text: ''
        }],
        responseRequired: true,
        response: []
      // }, {
      //   delay: 2000,
      //   title: 'Quick Replies',
      //   type: 'quickReplies',
      //   msg: [{
      //     text: '',
      //     quickReplies: [
      //       {
      //         title: 'Yes',
      //         postback: 'Good to know!',
      //       }, {
      //         title: 'No',
      //         postback: 'That\'s sad',
      //       },
      //     ],
      //   }],
      //   img: 'las la-reply-all',
      //   responseRequired: true,
      //   response: [],
      }],
      drivers: [],
      subDrivers: [],
      roleList: [],
      config: {
        panel: [true, true, true, true],
        searchMember: '',
        searchSurvey: '',
        stageType: 'lifecycle',
        activeStep: 1,
        initialLoading: true,
        loadingEmployees: false,
        loadingSurveys: false,
        savingStage: false,
        initialLoadingFilters: true,
        minDate: new Date().toISOString().substr(0, 10),
        activeTab: 'summary',
        tabs: [{
          title: 'About the miilestone',
          value: 'summary',
          count: 0
        }, {
          title: 'Design touchpoint',
          value: 'survey',
          count: 1
        }, {
          title: 'Select audience',
          value: 'audience',
          count: 2
        }, {
          title: 'Configuration',
          value: 'configure',
          count: 3
        }],
        emojiScale: {
          delay: 2000,
          title: 'Emoji Scale',
          description: 'Used to determine how someone feels about your company',
          type: 'scale',
          role: 'mood',
          img: 'las la-smile',
          msg: [{
            text: '',
            scaleType: 'emoji',
            scale: [
              {
                title: 'Terrible',
                img: 'crying',
                value: 1,
                postback: `I am very sorry to hear that 😞`
              }, {
                title: 'Disappointed',
                img: 'sad',
                value: 2,
                postback: 'Ah! That\'s bad.'
              }, {
                title: 'Okay',
                img: 'shocked',
                value: 3,
                postback: 'Hmmmmm alright!'
              }, {
                title: 'Good',
                img: 'happy',
                value: 4,
                postback: 'That\'s nice!'
              }, {
                title: 'Awesome',
                img: 'in-love',
                value: 5,
                postback: 'I am so glad to know that 🙂'
              }
            ]
          }],
          responseRequired: true,
          response: []
        }
      },
      filters: {
        default: {},
        main: {}
      },
      pagination: {
        rowsPerPage: 10
      },
      table: {
        loading: true,
        team: [],
        headers: [{
          text: 'Member Details',
          align: 'left',
          sortable: false
        }, {
          text: 'Mood',
          align: 'left',
          sortable: false
        }],
        notificationsHeaders: [{
          text: 'Member Details',
          align: 'left',
          sortable: false
        }, {
          text: 'Notifications',
          align: 'left',
          sortable: false
        }, {
          text: 'Reports',
          align: 'left',
          sortable: false
        }, {
          text: 'Actions',
          align: 'left',
          sortable: false
        }]
      },
      list: {
        employees: [],
        survey: [],
        timeDuration: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],
        timeIn: [{
          text: 'Before',
          value: '-'
        }, {
          text: 'After',
          value: '+'
        }],
        timeRef: [{
          text: 'Joining date',
          value: 'joining_date'
        }, {
          text: 'Offer date',
          value: 'offer_date'
        }],
        timeUnit: [{
          text: 'Days',
          value: 'days'
        }, {
          text: 'Weeks',
          value: 'weeks'
        }, {
          text: 'Months',
          value: 'months'
        }, {
          text: 'Years',
          value: 'years'
        }]
      },
      dialogs: {
        newQuestion: false,
        question_bank: false,
        campaign: false
      }
    };
  },
  computed: {
    ...mapState({
      stagesOrder: state => state.stages,
      user: state => state.user,
      users (state) {
        const adminUsers = state.companyUsersList;
        // this.$lodash.remove((v) => {
        //
        // })
        return adminUsers;
      }
    })
  },
  methods: {
    ...mapActions(['getCompanyUsers']),
    checkMove (e) {
      return e.draggedContext.futureIndex;
      // console.log("Future index: " + e.draggedContext.futureIndex);
    },
    addMoodQuestion () {
      if (!this.newSurvey.interactions || !this.newSurvey.interactions.length) {
        const temp = JSON.parse(JSON.stringify(this.config.emojiScale));
        // let interaction = [];
        if (temp.msg && temp.msg[0]) {
          temp.msg[0].text = `How do you feel about your last ${this.newStage.triggerTimeDuration} ${this.newStage.triggerTimeUnit} at ${this.user.company_name} ?`;
          temp.driver = 'Mood';
          temp.sub_driver = 'Mood';
        }
        this.newSurvey.interactions.push(temp);
        // interaction.push(temp);
        // this.newSurvey.interactions = JSON.parse(JSON.stringify(interaction));
      }
    },
    getRoles () {
      axios.get(`${process.env.VUE_APP_API_URL}driver/framework`).then((response) => {
        // this.config.initialLoading = false;
        if (response && response.data) {
          this.$nextTick(function a () {
            this.roleList = response.data;
            this.subDrivers = [];
            this.$lodash.each(this.roleList, (subDrivers, driver) => {
              this.drivers.push({
                name: driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2'),
                value: driver
              });
              this.$lodash.each(subDrivers, (subDriver) => {
                this.subDrivers.push({
                  name: subDriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2'),
                  value: subDriver
                });
              });
            });
            this.$forceUpdate();
          });
        }
      }, (response) => {
        // this.config.initialLoading = false;
        this.$store.dispatch('updateSnackbar', {
          color: 'error',
          show: true,
          text: 'Unable to fetch roles, Please try again later!'
        });
        throw new Error(response);
      });
    },
    getSubDrivers (selectedDriver) {
      this.$lodash.each(this.roleList, (subDrivers, driver) => {
        if (selectedDriver === driver) {
          this.subDrivers = [];
          this.$lodash.each(subDrivers, (subDriver) => {
            this.subDrivers.push({
              name: subDriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2'),
              value: subDriver
            });
          });
        }
      });
    },
    getRoleName (role) {
      role = role.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
      return role;
    },
    updateQuestion (ques, index, editFlag, lang) {
      this.$refs.newQuestion.selectedQuesType = {};
      this.$refs.newQuestion.selectedQuesType['0'] = JSON.parse(JSON.stringify(ques));
      this.$refs.newQuestion.editLang = false;
      this.$refs.newQuestion.editFlag = editFlag;
      this.$refs.newQuestion.questionIndex = index;
      this.newQuestion.questions = {};
      this.newQuestion.questions = {
        ...this.newQuestion.questions,
        ...this.selectedQuesType
      };
      this.questionSource = 'new';
      this.$refs.newQuestion.getRoles();
      this.$refs.newQuestion.dialogs.newQuestion = true;
      this.$refs.newQuestion.lang = lang;
    },
    editLanguageBasisQue (msg, lang_code, lang_name) {
      this.$refs.newQuestion.selectedQuesType = {};
      this.$refs.newQuestion.selectedQuesType[0] = JSON.parse(JSON.stringify(msg));
      this.$refs.newQuestion.dialogs.newQuestion = true;
      this.$refs.newQuestion.lang = {};
      this.$refs.newQuestion.lang.language_code = lang_code;
      this.$refs.newQuestion.lang.name = lang_name;
      this.$refs.newQuestion.editLang = true;
      console.log(this.$refs.newQuestion.selectedQuesType[0].msg_tl);
    },
    updateQuestionSource (source) {
      if (source === 'question_bank') {
        this.$refs[source].drivers = this.drivers;
        this.$refs[source].subDrivers = this.subDrivers;
        this.$refs[source].roleList = this.roleList;
        if (this.drivers && this.drivers.length > 0) {
          this.$refs[source].driver = this.drivers[0].value;
          this.$refs[source].getSubDrivers(this.drivers[0].value);
        } else {
          this.$refs[source].config.initialLoading = false;
          this.$refs[source].config.initialLoadingFilters = false;
        }
      } else if (source === 'campaign') {
        this.$refs[source].getCampaigns();
      }
      this.dialogs[source] = true;
      this.questionSource = source;
      this.$refs[source].dialogs[source] = true;
    },
    applyDrag (arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result[removedIndex];
        result.splice(removedIndex, 1);
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      this.$lodash.each(result, (v, k) => {
        v.index = k;
        v.enabled = true;
        v.status = 'updated';
      });
      return result;
    },
    getIPayload (index) {
      return this.newSurvey[index];
    },
    getDragPosition (type) {
      let style = 'position:absolute;left:7%;top:-33%;z-index:2';
      if (type === 'closeEnded') {
        style = 'position:absolute;left:7%;top:-27%;z-index:2';
      } else if (type === 'scale') {
        style = 'position:absolute;left:7%;top:-21%;z-index:2';
      }
      return style;
    },
    editAction (ques, index, editFlag, lang) {
      this.updateQuestion(ques, index, editFlag, lang);
    },
    deleteAction (i) {
      this.newSurvey.interactions.splice(i, 1);
    },
    duplicateAction (item) {
      const temp = JSON.parse(JSON.stringify(item));
      delete temp.interaction_id;
      this.newSurvey.interactions.push(temp);
    },
    getImgUrl (pet) {
      const images = require.context('@/assets/', false, /\.png$/);
      return images(`./${pet}.png`);
    },
    onDrop (dropResult) {
      if (dropResult.payload) {
        dropResult.payload = JSON.parse(JSON.stringify(dropResult.payload));
      }
      this.newSurvey.interactions = this.applyDrag(this.newSurvey.interactions, dropResult);
    },
    onDragEnd () {
      this.drag.startDragging = false;
    },
    onResize (e) {
      // console.log(e);
    },
    onMove (evt) {
      if (evt && evt.draggedContext && evt.draggedContext.futureIndex > -1 &&
      this.newSurvey.interactions[evt.draggedContext.futureIndex]) {
        this.newSurvey.interactions[evt.draggedContext.futureIndex] =
        JSON.parse(JSON.stringify(this.newSurvey.interactions[evt.draggedContext.futureIndex]));
      }
      this.drag.droppingNow = true;
    }
  },
  created () {
    window.scrollTo(0, 0);
    document.addEventListener('resize', this.onResize);
  },
  destroyed () {
    document.removeEventListener('resize', this.onResize);
  },
  watch: {
    pagination: {
      handler () {
        if (!this.config.initialLoading) {
          this.getTeam();
        }
      },
      deep: true
    }
    // config: {
    //   handler() {
    //     if (this.config.searchMember) {
    //       this.config.searchMember.reports = true;
    //       this.config.searchMember.notifications = true;
    //       setTimeout(() => {
    //         this.config.searchMember = '';
    //         this.config.savingStageEmployees = false;
    //       }, 50);
    //     }
    //   },
    //   deep: true,
    // },
  },
  beforeMount () {
    this.getRoles();
    this.getCompanyUsers();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.driver-name, .sub-driver-name {
  .v-chip.v-size--small {
    height : auto !important;
    padding: 5px 10px !important;
  }
  .v-chip__content {
    white-space: normal !important;
    line-height: normal !important;
  }
}
.survey-cards {
  .v-card__text {
    // height: 8em;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.intrct-block {
  border-radius: 4px;
  // height: 5.5em;
  overflow-y: auto;
}
.maximum-step-content {
  // max-height: 640px!important;
}
.stepper-step-content {
  padding: 0 20px 10px 0;
  height: calc(100vh - 10em);
  .step-content {
    // margin-bottom: 20px;
    height: calc(100vh - 13em);
    min-height: calc(100vh - 13em);
    // padding: 0px;
    .maximum-step-content {
      height: calc(100vh - 13em);
      max-height: calc(100vh - 13em);
      // overflow-y:hidden;
    }
  }
  .step-actions {

  }
}
.sortable-ghost {
  margin-left: 48px !important;
  margin-right: 48px !important;
  max-width: 100% !important;
  border-radius: 8px;
  border: 1px dashed #4A00E0;
  background-color: white;
  .v-card, .delay, .title {
    opacity: 0;
  }
}
.interactions .interaction-card {
  // height: calc(100vh - 7em);
  .drag-container {
    // height: calc(100vh - 13.1em);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .smooth-dnd-container {
    // min-height: 70vh;
  }
}
.smooth-dnd-draggable-wrapper {
  padding-top: 16px!important;
}
.subheading-text {
  font-size: var(--content-sub-size);
}
</style>
